import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Button from "../../../../../components/button/Button";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"
import Input from "../../../../../components/textbox/Input";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import SiavrServices from "../../../../../services/SiavrServices";
import OggettiUtili from "../../../../../utils/OggettiUtili"

class Vaccinazioni extends Component {

    state = {
        vaccinazioni: {
            precedentiVaccinazioni: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "3" : "",
            tableVaccinazioni: [],
            errorMessage: ""
        },

        clicksVaccinazioni: 0,
        boxesVaccinazione: [],

        listaPrecedentiVaccinazioni: [      //da dizionario
            {codice: "3", descrizione: "Non Noto"},
            {codice: "1", descrizione: "Si"},
            {codice: "2", descrizione: "No"}
        ],
        sendRequest: false,
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.handleClickVaccinazioni = this.handleClickVaccinazioni.bind(this);
        this.aggiungiVaccinazione = this.aggiungiVaccinazione.bind(this);
        this.validate = this.validate.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this);
        this.uniqueObjectVaccinazioni = this.uniqueObjectVaccinazioni.bind(this);
        this.buildParams = this.buildParams.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
        this.riceviValoreDose = this.riceviValoreDose.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.vaccinazioni) {
            let propsVaccinazioni = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.vaccinazioni));
            let stateVaccinazioni = this.state.vaccinazioni

            stateVaccinazioni.precedentiVaccinazioni = propsVaccinazioni.precedentiVaccinazioni ? propsVaccinazioni.precedentiVaccinazioni : ""
            if (propsVaccinazioni.tableVaccinazioni) {
                for (let i = 0; i < propsVaccinazioni.tableVaccinazioni.length; i++) {
                    this.aggiungiVaccinazione()
                    stateVaccinazioni.tableVaccinazioni[i].doseVaccinazioni = propsVaccinazioni.tableVaccinazioni[i].doseVaccinazioni ? propsVaccinazioni.tableVaccinazioni[i].doseVaccinazioni : ""
                    stateVaccinazioni.tableVaccinazioni[i].dataVaccinazioni = propsVaccinazioni.tableVaccinazioni[i].dataVaccinazioni ? propsVaccinazioni.tableVaccinazioni[i].dataVaccinazioni : ""
                    stateVaccinazioni.tableVaccinazioni[i].commercialeVaccinazioni = propsVaccinazioni.tableVaccinazioni[i].commercialeVaccinazioni ? propsVaccinazioni.tableVaccinazioni[i].commercialeVaccinazioni : ""
                    stateVaccinazioni.tableVaccinazioni[i].lottoVaccinazioni = propsVaccinazioni.tableVaccinazioni[i].lottoVaccinazioni ? propsVaccinazioni.tableVaccinazioni[i].lottoVaccinazioni : ""

                    this.handleClickVaccinazioni(i)
                }
            } else if (stateVaccinazioni.precedentiVaccinazioni === "1" && !propsVaccinazioni.tableVaccinazioni) {
                this.aggiungiVaccinazione()
                this.handleClickVaccinazioni(0)
            }

            this.setState({vaccinazioni: stateVaccinazioni})

        } else {
            this.sendRequest(this.buildParams(true))
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState !== this.state) {
            let objFinal = this.createJsonForBackend()
            this.props.setVaccinazioni(this.state.vaccinazioni, this, objFinal);
        }
    }

    buildParams(sendRequest) {
        let params = {
            idPaziente: this.props.segnalazioneCopia.pazienteId,
            malattia: this.props.segnalazioneCopia.malattia,
            cfOperatore: this.props.segnalazioneCopia.idOperatore
        };
        this.setState({sendRequest: sendRequest})
        let object = JSON.parse(JSON.stringify(params))
        return Utils.removeEmptyValueFromObject(object);
    }

    sendRequest(params) {

        let stateVaccinazioni = this.state.vaccinazioni

        if (this.props.vaccinazioni) {
            SiavrServices.getVaccinazioni(params).then((data) => {
                let datiVaccinazioni = data.data;
                if (datiVaccinazioni.listaVaccinazioni.length > 0 && datiVaccinazioni.errorMessage === null) {
                    stateVaccinazioni.precedentiVaccinazioni = "1"
                    for (let i = 0; i < datiVaccinazioni.listaVaccinazioni.length; i++) {
                        stateVaccinazioni.tableVaccinazioni.push({
                            doseVaccinazioni: "",
                            dataVaccinazioni: "",
                            commercialeVaccinazioni: "",
                            lottoVaccinazioni: ""
                        })
                        stateVaccinazioni.tableVaccinazioni[i].doseVaccinazioni = datiVaccinazioni.listaVaccinazioni[i].dose ? (datiVaccinazioni.listaVaccinazioni[i].dose+25).toString() : ""
                        let dataEffettuazione = datiVaccinazioni.listaVaccinazioni[i].dataEffettuazione ? Utils.transformTimeStampForFrontend(datiVaccinazioni.listaVaccinazioni[i].dataEffettuazione) : ""
                        stateVaccinazioni.tableVaccinazioni[i].dataVaccinazioni = dataEffettuazione
                        stateVaccinazioni.tableVaccinazioni[i].commercialeVaccinazioni = datiVaccinazioni.listaVaccinazioni[i].codiceNomeCommerciale ? datiVaccinazioni.listaVaccinazioni[i].codiceNomeCommerciale : ""
                        stateVaccinazioni.tableVaccinazioni[i].lottoVaccinazioni = datiVaccinazioni.listaVaccinazioni[i].codiceLotto ? datiVaccinazioni.listaVaccinazioni[i].codiceLotto : ""
                        this.handleClickVaccinazioni(i)
                    }
                } else if (datiVaccinazioni.listaVaccinazioni.length === 0 && datiVaccinazioni.errorMessage === null) {
                    stateVaccinazioni.errorMessage = "Non sono presenti dati relativi alle vaccinazioni precedenti"
                    stateVaccinazioni.precedentiVaccinazioni = "2"
                } else {
                    stateVaccinazioni.errorMessage = datiVaccinazioni.errorMessage === "Paziente non trovato in anagrafe vaccinale" ? datiVaccinazioni.errorMessage : "L'operazione non è andata a buon fine"
                    stateVaccinazioni.precedentiVaccinazioni = "3"
                }
                this.setState({vaccinazioni: stateVaccinazioni})
            }).catch(() => {
                stateVaccinazioni.errorMessage = "L'operazione non è andata a buon fine"
                stateVaccinazioni.precedentiVaccinazioni = "3"
                this.setState({vaccinazioni: stateVaccinazioni});
            })
        }

    }

    validate() {
        for (let i = 0; i < this.state.vaccinazioni.tableVaccinazioni.length; i++) {
            let validateDataVaccinazione = Utils.checkDateInterval(this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni, "31/12/1899");
            let checkTodayDataVaccinazione = Utils.checkDateLowerToday(this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni);
            if (validateDataVaccinazione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0Z"]), 1
                )
            } else if (checkTodayDataVaccinazione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AA"]), 1
                )
            }
            if (this.state.vaccinazioni.tableVaccinazioni[i].doseVaccinazioni === "" && this.state.vaccinazioni.precedentiVaccinazioni === "1") {
                return (
                    this.props.aggiungiToaster(
                        ["Campo \"Dose\" mancante"]), 1
                )
            }
        }

        let vaccinazioni = JSON.parse(JSON.stringify(this.state.vaccinazioni))
        let arrayVaccinazioniPulito = Utils.removeEmptyValueFromObject(vaccinazioni.tableVaccinazioni)
        vaccinazioni.tableVaccinazioni = Utils.eliminaNullArray(arrayVaccinazioniPulito)

        let objFinal = this.createJsonForBackend(this.uniqueObjectVaccinazioni(vaccinazioni))
        this.props.setVaccinazioni(this.state.vaccinazioni, this, objFinal)

    }

    uniqueObjectVaccinazioni(elVaccinazioni) {
        const tmpvaccinazioni = new Map()
        let vaccinazioni = JSON.parse(JSON.stringify(this.state.vaccinazioni))

        const rsVaccinazioni = elVaccinazioni.tableVaccinazioni.reduce((acc, e) => {
            if (tmpvaccinazioni.has(e.doseVaccinazioni) && tmpvaccinazioni.has(e.dataVaccinazioni) && tmpvaccinazioni.has(e.commercialeVaccinazioni) && tmpvaccinazioni.has(e.lottoVaccinazioni)) {
                if (!tmpvaccinazioni.get(e.doseVaccinazioni).includes(e.jobid) && !tmpvaccinazioni.get(e.dataVaccinazioni).includes(e.jobid) && !tmpvaccinazioni.get(e.commercialeVaccinazioni).includes(e.jobid) && !tmpvaccinazioni.get(e.lottoVaccinazioni).includes(e.jobid)) {
                    acc.push(e)
                    tmpvaccinazioni.set(e.doseVaccinazioni, [...tmpvaccinazioni.get(e.doseVaccinazioni), e.jobid])
                    tmpvaccinazioni.set(e.dataVaccinazioni, [...tmpvaccinazioni.get(e.dataVaccinazioni), e.jobid])
                    tmpvaccinazioni.set(e.commercialeVaccinazioni, [...tmpvaccinazioni.get(e.commercialeVaccinazioni), e.jobid])
                    tmpvaccinazioni.set(e.lottoVaccinazioni, [...tmpvaccinazioni.get(e.lottoVaccinazioni), e.jobid])
                }
            } else {
                acc.push(e)
                tmpvaccinazioni.set(e.doseVaccinazioni, [e.jobid])
                tmpvaccinazioni.set(e.dataVaccinazioni, [e.jobid])
                tmpvaccinazioni.set(e.commercialeVaccinazioni, [e.jobid])
                tmpvaccinazioni.set(e.lottoVaccinazioni, [e.jobid])
            }
            return acc
        }, [])

        vaccinazioni.tableVaccinazioni = rsVaccinazioni
        return vaccinazioni
    }

    createJsonForBackend(stateVaccinazioni) {

        let vaccinazioni = JSON.parse(JSON.stringify(stateVaccinazioni ? stateVaccinazioni : this.state.vaccinazioni));
        let VaccinazioniPulito = {}
        let listaVaccinazioniPulito = []
        let arrayVaccinazioniPulito = []

        for (let i = 0; i < vaccinazioni.tableVaccinazioni.length; i++) {
            arrayVaccinazioniPulito = []
            let VaccinazioniSingolo = Utils.removeEmptyValueFromObject(vaccinazioni.tableVaccinazioni[i])

            if (arrayVaccinazioniPulito.length > 0) {
                VaccinazioniSingolo["tableVaccinazioni"] = arrayVaccinazioniPulito
            } else {
                Utils.removeFieldFromObject(VaccinazioniSingolo, "tableVaccinazioni")
            }
            if (!Utils.isEmpty(VaccinazioniSingolo)) {
                listaVaccinazioniPulito.push(VaccinazioniSingolo)
            }
        }
        if (listaVaccinazioniPulito.length > 0) {
            VaccinazioniPulito = listaVaccinazioniPulito
        }
        vaccinazioni.tableVaccinazioni = Utils.removeEmptyValueFromObject(VaccinazioniPulito)
        return vaccinazioni
    }

    riceviValoreDose(event) {
        let vaccinazioni = this.state.vaccinazioni
        if (event && event.target.id.includes("doseVaccinazioni")) {
            let indice = event.target.id.replace("doseVaccinazioni", "")
            vaccinazioni.tableVaccinazioni[indice].doseVaccinazioni = event.target.value
            this.handleClickVaccinazioni(this.state.clicksVaccinazioni - 1);
        }
        this.setState({vaccinazioni: vaccinazioni})
    }

    riceviValore(field, event) {
        let vaccinazioni = this.state.vaccinazioni

        if (field && !field.currentTarget && field.includes("commercialeVaccinazioni")) {
            let indice = field.replace("commercialeVaccinazioni", "")
            vaccinazioni.tableVaccinazioni[indice].commercialeVaccinazioni = event.target.value
            this.handleClickVaccinazioni(this.state.clicksVaccinazioni - 1);
        } else if (field && !field.currentTarget && field.includes("lottoVaccinazioni")) {
            let indice = field.replace("lottoVaccinazioni", "")
            vaccinazioni.tableVaccinazioni[indice].lottoVaccinazioni = event.target.value
            this.handleClickVaccinazioni(this.state.clicksVaccinazioni - 1);
        } else if (field.currentTarget.id.includes("dataVaccinazioni")) {
            let indice = field.currentTarget.id.replace("dataVaccinazioni", "")
            vaccinazioni.tableVaccinazioni[indice].dataVaccinazioni = field.target.value
            this.handleClickVaccinazioni(this.state.clicksVaccinazioni - 1);
        } else {
            vaccinazioni[field.currentTarget.id] = field.currentTarget.value
        }

        if (field && field.currentTarget && field.currentTarget.value !== "1" && field.currentTarget.id === "precedentiVaccinazioni") {

            if (field.currentTarget.value === "3")
                vaccinazioni.precedentiVaccinazioni = field.currentTarget.value + "*"
            else
                vaccinazioni.precedentiVaccinazioni = field.currentTarget.value
            vaccinazioni.tableVaccinazioni = [{
                doseVaccinazioni: "",
                dataVaccinazioni: "",
                commercialeVaccinazioni: "",
                lottoVaccinazioni: ""
            }]

            this.setState({vaccinazioni: vaccinazioni})
            this.handleClickVaccinazioni(0);
        } else if (field && field.currentTarget && field.currentTarget.value === "1" && field.currentTarget.id === "precedentiVaccinazioni") {
            this.aggiungiVaccinazione()
            this.handleClickVaccinazioni(0)
        }

        this.setState({vaccinazioni: vaccinazioni})

    }

    aggiungiVaccinazione() {
        let vaccinazioniCopia = this.state.vaccinazioni;

        vaccinazioniCopia.tableVaccinazioni.push({
            doseVaccinazioni: "",
            dataVaccinazioni: "",
            commercialeVaccinazioni: "",
            lottoVaccinazioni: ""
        })

        this.setState({vaccinazioni: vaccinazioniCopia})
    }

    handleClickVaccinazioni(clicksVaccinazioni) {

        let {t} = this.props;
        let clicks = clicksVaccinazioni + 1
        let boxesVaccinazione = [];

        for (let i = 0; i < clicks; i++)
            boxesVaccinazione.push(
                <tbody>
                <tr>
                    <td>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <Select
                                value={this.state.vaccinazioni.tableVaccinazioni[i].doseVaccinazioni}
                                id={"doseVaccinazioni" + i}
                                vaccinazione={false}
                                old={true}
                                onChange={(e) => this.riceviValoreDose(e)}
                                functionMap={OggettiUtili.DoseVaccinazione.map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                    </td>
                    <td>
                        <div className={`col-lg-11 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <Calendar
                                id={"dataVaccinazioni".concat(i)}
                                value={this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni}
                                field={"dataVaccinazioni".concat(i)}
                                onChange={this.riceviValore}
                                errorMessage={"Data non valida"}
                                error={(this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni === "" || this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.vaccinazioni.tableVaccinazioni[i].dataVaccinazioni), "-")
                                }
                                placeholder={t("DatiSpecifici.Vaccinazioni.dataSomministrazione")}
                            >
                            </Calendar>
                        </div>
                    </td>
                    <td>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <Input
                                id={"commercialeVaccinazioni" + i}
                                onChange={this.riceviValore}
                                field={"commercialeVaccinazioni" + i}
                                value={this.state.vaccinazioni.tableVaccinazioni[i].commercialeVaccinazioni}
                                placeholder={t("DatiSpecifici.Vaccinazioni.nome")}
                                // disabled={}
                            />
                        </div>
                    </td>
                    <td>
                        <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <Input
                                id={"lottoVaccinazioni" + i}
                                onChange={this.riceviValore}
                                field={"lottoVaccinazioni" + i}
                                value={this.state.vaccinazioni.tableVaccinazioni[i].lottoVaccinazioni}
                                placeholder={t("DatiSpecifici.Vaccinazioni.lotto")}
                                // disabled={}
                            />
                        </div>
                    </td>
                </tr>
                </tbody>
            )

        this.setState({boxesVaccinazione: boxesVaccinazione, clicksVaccinazioni: clicks});
    }


    render() {

        const {t} = this.props;

        return (

            <div>
                <h6>{this.props.t("DatiSpecifici.Vaccinazioni.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={styles.mandatoryColor}>{this.state.vaccinazioni.errorMessage}</div>
                <div style={{marginTop: "1rem"}} className={"container"}>
                    <div className={"row"}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.Vaccinazioni.precedenteVaccinazione")}
                                {/*<span className={styles.mandatoryColor}>*</span>*/}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3" style={{marginTop: "1rem"}}>
                        <Select
                            value={this.state.vaccinazioni.precedentiVaccinazioni === "3*"? "3" : this.state.vaccinazioni.precedentiVaccinazioni}
                            onChange={this.riceviValore}
                            old={true}
                            id={"precedentiVaccinazioni"}
                            functionMap={this.state.listaPrecedentiVaccinazioni.map((oggetto) => {
                                return (<option value={oggetto.codice}style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                            })}
                            vaccinazione={true}
                            addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.vaccinazioni.precedentiVaccinazioni === "3"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                        >

                        </Select>
                    </div>

                    {this.state.vaccinazioni.precedentiVaccinazioni === "1" ?
                        <div>
                            <div className={"col-lg-12"} style={{marginTop: "2rem"}}>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr className="table-info">
                                        <td scope="col">{t("DatiSpecifici.Vaccinazioni.doseTabella")}<span
                                            className={styles.mandatoryColor}>*</span></td>
                                        <td scope="col">{t("DatiSpecifici.Vaccinazioni.dataSomministrazione")}</td>
                                        <td scope="col">{t("DatiSpecifici.Vaccinazioni.nome")}</td>
                                        <td scope="col">{t("DatiSpecifici.Vaccinazioni.lotto")}</td>
                                    </tr>
                                    </thead>
                                    {this.state.boxesVaccinazione}
                                </table>
                            </div>

                            <div className={"row"}>
                                <div className="col-12 text-center">
                                    <Button text={t("DatiSpecifici.Vaccinazioni.dose")}
                                            disabled={this.state.vaccinazioni.precedentiVaccinazioni !== "1"}
                                            className={"btnWhite col-lg-2 "}
                                            style={{height: "2rem", marginTop: "1rem"}}
                                            onClick={() => {
                                                this.aggiungiVaccinazione();
                                                this.handleClickVaccinazioni(this.state.clicksVaccinazioni)
                                            }}
                                    >
                                    </Button>
                                </div>
                            </div>
                        </div> : null}
                </div>
            </div>


        );
    }
}

export default withTranslation(
    'common'
)(
    Vaccinazioni
)
